import React from 'react';
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from '../../Server'
import axios from 'axios';

class CreateDepartment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            parentid: '0',
            name: "",
            subid: '',
            details: '',
            oldTypeData: []
        }
    }


    onChangeInput = (e) => {
        e.preventDefault();
        // this.checkRequirement(e.target.name, e.target.value);
        this.setState({ [e.target.name]: e.target.value })
    }
    handleSubmit = () => {
        if (this.props.iseditmode) {
            var data = {
                name: this.state.name,
                details: this.state.details,
                id: this.state.id,
                jwt: jwt
            }
            var _this = this;
            let headers = {
                'user_id': (ud.id).toString(),
                'session_id': (ud.session_id).toString(),
                'user_type': (ud.usertype).toString(),
                'main_id': (ud.main_id).toString(),
                'jwt_token': (jwt),
                'c_id': (ud.c_id).toString()
            }
            axios.post(`${SERVER_IP}/update/types`, data, { withCredentials: true, headers: headers })
                .then(function (response) {
                    if (response.data.error === false) {
                        _this.props.updateTypeForm()
                    } else {
                        auth_response_flow(response.data, (return_response) => {
                            if (return_response.error === false && return_response.retry === true) {
                                _this.handleSubmit();
                            }
                        })
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });

        }
        else {
            var data = {
                name: this.state.name,
                details: this.state.details,
                parent_id: this.props.parent,
                ud: ud.main_id,
                jwt: jwt
            }
            var _this = this;
            let headers = {
                'user_id': (ud.id).toString(),
                'session_id': (ud.session_id).toString(),
                'user_type': (ud.usertype).toString(),
                'main_id': (ud.main_id).toString(),
                'jwt_token': (jwt),
                'c_id': (ud.c_id).toString()
            }
            axios.post(`${SERVER_IP}/create/types`, data, { withCredentials: true, headers: headers })
                .then(function (response) {
                    if (response.data.error === false) {
                        _this.props.updateTypeForm()
                    }else{
                        auth_response_flow(response.data, (return_response) => {
                            if (return_response.error === false && return_response.retry === true) {
                                _this.handleSubmit();
                            }
                        })
                    }
                  
                })
                .catch(function (error) {
                    console.log(error);
                });
        }


    }
    componentDidMount() {
        
        if (this.props.iseditmode) {
            this.setState({ name: this.props.selectednode.name, id: this.props.selectednode.id, details: this.props.selectednode.details })
        }
    }

    render() {

        return (
            <div>
                <div>
                    {this.props.iseditmode ?
                        <h4 class="text-black">Edit Types</h4>
                        :
                        <h4 class="text-black">Category</h4>
                    }
                    <div class="form-group">
                        <label for="exampleInputEmail1">Name</label>
                        <input type="text" onChange={this.onChangeInput} class="form-control" name="name" value={this.state.name} placeholder="Enter Name" />
                    </div>

                    <div class="form-group">
                        <label for="exampleInputEmail1">Details</label>
                        <textarea onChange={this.onChangeInput} class="form-control" name="details" value={this.state.details} placeholder="Enter Details" rows="4" cols="50"></textarea>
                        <small><span className="text-primary">*</span>Word limit for the field is 2000 character</small>
                    </div>
                    <button type="submit" onClick={this.handleSubmit} class="btn btn-primary">Submit</button>

                    <p className="text-primary mt-2"><strong>Note:</strong> Category can be Departments, Subdepartments, Units, Equipment etc.</p>
                </div>
            </div>

        )
    }
}
export default CreateDepartment